export default __webpack_public_path__ + "static/media/UB_logotyp_gra_RGB.804656cd.png";